import axios from 'axios';

axios.defaults.baseURL = process.env.REACT_APP_BACKEND_URI;

// Crear una instancia de axios
const axiosInstance = axios.create();

// Agregar un interceptor para agregar el token a cada solicitud
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Agregar un interceptor para manejar errores
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    // Token no válido o usuario deshabilitado
    if (error.response) {
      if (error.response.status === 401) {
        // Verificar si el mensaje indica específicamente que el usuario está deshabilitado
        if (error.response.data === "Usuario deshabilitado.") {
          localStorage.removeItem("token");
          window.location.href = '/login?error=disabled';
        } else {
          // Otro error de autorización
          localStorage.removeItem("token");
          window.location.href = '/login';
        }
      }
    }
    return Promise.reject(error);
  }
);

// Función para validar el estado del usuario
export const validarEstadoUsuario = async () => {
  try {
    await axiosInstance.get('/Usuario/ValidateUserStatus');
    return true;
  } catch (error) {
    // El interceptor ya maneja los errores de autorización
    return false;
  }
};

const requestGenerico = {
    get: (url, config = undefined) => axiosInstance.get(url, config),
    post: (url, body, config = undefined) => axiosInstance.post(url, body, config),
    put: (url, body, config = undefined) => axiosInstance.put(url, body, config),
    delete: (url, config = undefined) => axiosInstance.delete(url, config),
    validarEstadoUsuario
};

export default requestGenerico;